import {
  required,
  alphaNum,
  email,
  size,
  max,
} from '@helpers/validationRules.js'

export const DEFAULT_URL_EMAIL_MAX = 100

export const loginConfig = {
  email: {
    required: true,
    email: true,
    max: DEFAULT_URL_EMAIL_MAX,
  },
  code: {
    required: true,
    alphaNum: true,
    size: 5,
  },
}

export const reportConfig = {
  name: {
    max: 100,
  },
  email: {
    max: DEFAULT_URL_EMAIL_MAX,
  },
  address: {
    max: 250,
  },
  urls: {
    max: 2560,
  },
  summary: {
    required: true,
    max: 10000,
  },
}

export const discussionConfig = {
  comment: {
    required: true,
    max: 5000,
  },
}

function _getValidationFunctions(config) {
  const validationFunctions = {}

  for (let [field, validations] of Object.entries(config)) {
    validationFunctions[field] = Object.entries(validations).map(
      ([key, value]) => {
        if (key === 'required') return required
        if (key === 'max') return max(value)
        if (key === 'email') return email
        if (key === 'alphaNum') return alphaNum
        if (key === 'size') return size(value)
        if (key === 'custom') return value
        throw new Error('Unrecognised validation function')
      }
    )
  }

  config.validation = validationFunctions
}

const _configs = [loginConfig, reportConfig, discussionConfig]

_configs.forEach((config) => _getValidationFunctions(config))
